interface Props {
  suggestionsContainerClass?: string;
  suggestionsContentClass?: string;
  children: JSX.Element;
}

export default function SuggestionsContainer({
  suggestionsContainerClass,
  suggestionsContentClass,
  children,
}: Props) {
  return (
    <div className={`suggestions-container ${suggestionsContainerClass}`}>
      <div className={`suggestions-content-container ${suggestionsContentClass}`}>{children}</div>
    </div>
  );
}
